/** Estimated annual council tax by London postcode district prefix (e.g. "SW1", "E14"). */
export const LONDON_COUNCIL_TAX_ANNUAL: Record<string, number> = {
  E1: 1680,
  E2: 1720,
  E3: 1650,
  E4: 1580,
  E5: 1620,
  E6: 1540,
  E7: 1560,
  E8: 1700,
  E9: 1640,
  E10: 1520,
  E11: 1580,
  E12: 1540,
  E13: 1560,
  E14: 1820,
  E15: 1680,
  E16: 1620,
  E17: 1540,
  E18: 1480,
  EC1: 1950,
  EC2: 1980,
  EC3: 1920,
  EC4: 1900,
  N1: 1750,
  N2: 1680,
  N3: 1620,
  N4: 1580,
  N5: 1720,
  N6: 1780,
  N7: 1680,
  N8: 1540,
  N9: 1480,
  N10: 1620,
  N11: 1560,
  N12: 1580,
  N13: 1520,
  N14: 1480,
  N15: 1620,
  N16: 1680,
  N17: 1540,
  N18: 1460,
  N19: 1720,
  N20: 1580,
  N21: 1520,
  N22: 1560,
  NW1: 1820,
  NW2: 1680,
  NW3: 1920,
  NW4: 1580,
  NW5: 1750,
  NW6: 1780,
  NW7: 1520,
  NW8: 1980,
  NW9: 1540,
  NW10: 1580,
  NW11: 1680,
  SE1: 1780,
  SE2: 1520,
  SE3: 1620,
  SE4: 1680,
  SE5: 1720,
  SE6: 1580,
  SE7: 1540,
  SE8: 1650,
  SE9: 1520,
  SE10: 1750,
  SE11: 1780,
  SE12: 1540,
  SE13: 1620,
  SE14: 1680,
  SE15: 1650,
  SE16: 1720,
  SE17: 1680,
  SE18: 1540,
  SE19: 1580,
  SE20: 1520,
  SE21: 1780,
  SE22: 1720,
  SE23: 1680,
  SE24: 1750,
  SE25: 1540,
  SE26: 1580,
  SE27: 1620,
  SE28: 1480,
  SW1: 1980,
  SW2: 1720,
  SW3: 2050,
  SW4: 1780,
  SW5: 1920,
  SW6: 1850,
  SW7: 2020,
  SW8: 1750,
  SW9: 1680,
  SW10: 1880,
  SW11: 1780,
  SW12: 1680,
  SW13: 1620,
  SW14: 1580,
  SW15: 1650,
  SW16: 1580,
  SW17: 1620,
  SW18: 1680,
  SW19: 1620,
  SW20: 1560,
  W1: 2100,
  W2: 1950,
  W3: 1720,
  W4: 1680,
  W5: 1620,
  W6: 1780,
  W7: 1580,
  W8: 2020,
  W9: 1750,
  W10: 1680,
  W11: 1880,
  W12: 1650,
  W13: 1580,
  W14: 1820,
  WC1: 1920,
  WC2: 1980,
};

export const DEFAULT_LONDON_COUNCIL_TAX_ANNUAL = 1650;

export function postcodeDistrict(postcode: string): string | null {
  const normalised = postcode.trim().toUpperCase().replace(/\s+/g, "");
  const match = normalised.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)/);
  if (!match) return null;
  const district = match[1];
  if (LONDON_COUNCIL_TAX_ANNUAL[district]) return district;
  const withoutSuffix = district.replace(/[A-Z]$/, "");
  if (LONDON_COUNCIL_TAX_ANNUAL[withoutSuffix]) return withoutSuffix;
  return district;
}

export function estimateAnnualCouncilTax(postcode: string): number {
  const district = postcodeDistrict(postcode);
  if (!district) return DEFAULT_LONDON_COUNCIL_TAX_ANNUAL;
  return (
    LONDON_COUNCIL_TAX_ANNUAL[district] ??
    LONDON_COUNCIL_TAX_ANNUAL[district.replace(/[A-Z]$/, "")] ??
    DEFAULT_LONDON_COUNCIL_TAX_ANNUAL
  );
}
